import { MaintenanceWindowPreviewPatchManagementGzDataProvider } from '../dataProvider/MaintenanceWindowPreviewPatchManagementGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MaintenanceWindowPreviewPatchManagementDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MaintenanceWindowPreviewPatchManagementGzDataProvider);
  }
}
